export default __webpack_public_path__ + "static/media/CONTACT.12f84c74.svg";